import { Modal } from "@mui/material";
import { Fragment, ReactElement } from "react";
import CloseIcon from "../../assets/images/Close.svg";
import EditModal from "../../assets/images/EditModal.svg";
import MuiAlert from "../Alert/Alert";

import "./Modal.scss";

export default function MUIModal(props: {
  open: boolean; close: CallableFunction; children: ReactElement; style: string;
  showAlert?: any; closeAlert?: CallableFunction; editable?: boolean; openEdit?: () => void
}) {

  const handleCloseAlert = () => {
    if (props.closeAlert) {
      props.closeAlert();
    }
  }
  return (
    <Modal open={props.open} classes={{ root: "modal-container" }}>
      <>
        <MuiAlert error={props.showAlert?.isError} message={props.showAlert?.message} open={props.showAlert?.open}
          onClose={handleCloseAlert} />
        <div className={`card ${props.style}`}>
          <div className="close">
            {props.editable ? <img className="img edit" src={EditModal} alt={"Close"}
              onClick={() => props.openEdit?.()} /> : <Fragment />}
            <img className="img" src={CloseIcon} alt={"Close"} onClick={() => { props.close(); }} />
          </div>
          {props.children}
        </div>
      </>
    </Modal >
  );
}